<div *ngIf="title" class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis pb-1em">{{ title | translate }}</div>
